export default [
	{
		modulo: 36,
		privilegio: 369,
		routerName: 'gestao-fadiga',
		routerPath: '/gestao-fadiga',
		componentName: 'GestaoFadiga',
		componentPath: 'modules/layout/gestao-fadiga/main'
	},
]
